<ps-ui-modal class="psid-modal">
  <ps-ui-modal-title> </ps-ui-modal-title>
  <ps-ui-modal-body>
    <div class="psid-modal-data col-xs-12 col-sm-8 col-md-8 col-md-offset-2">
      <p class="uploadText">Include List</p>
      <p class="lableText">
        {{ includePsidsToDisplay }}
      </p>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer> </ps-ui-modal-footer>
</ps-ui-modal>
